module.exports = __webpack_public_path__ + "static/media/22.2a74bd6a.JPG";